import TextComponent, { TextComponentProps } from './TextComonent'

export default TextComponent

export { TextComponentProps, TextComponent }
